import { Table, Space } from 'antd';
import { formatDate, convertCentsIntoDollar } from '../../../../helpers/genericHelper';
import Data from '../../../CustomText/data';

export default function PaymentAttemptsList({
    paymentAttempts
}) {
  return (
    <Table dataSource={paymentAttempts}>
      <Table.Column
        title="Date"
        dataIndex="createTs"
        key="createTs"
        render={(createTs, data) => formatDate(data?.paymentSuccessTs || data?.createTs, true)}
      />
      <Table.Column
        title="Status"
        dataIndex="paymentStatus"
        key="paymentStatus"
        render={(paymentStatus) => paymentStatus.toUpperCase()}
      />
      <Table.Column
        title="Amount"
        dataIndex="paymentAmount"
        key="paymentAmount"
        render={(paymentAmount) => convertCentsIntoDollar(paymentAmount)} 
      />
      <Table.Column
        title="Amount"
        dataIndex="paymentAmount"
        key="paymentAmount"
        render={(paymentAmount, data) => {
          return <Space direction='vertical'>
            { data?.paymentFailedReason !== "NONE" && <Data isTag tagColor="processing" title="Payment failure reason" value={data?.paymentFailedReason}/>  }
            <Data isTag tagColor="processing" title="Payment Mode" value={data?.paymentMode}/>
            <Data isTag tagColor="processing" title="Manual Payment" value={data?.manualPayment ? "YES" : "NO"}/>
          </Space>
        }} 
      />
    </Table>
  )
}

